module.exports = __webpack_public_path__ + "img/clothing179.2b0abfb6.jpg";